import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const getProductIntermediateUseSoldList = ({
  productId,
  objectId,
  objects,
  setBuyerOptions = function () {
    return;
  },
  setObjects,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl + "/api/business/product/" + productId + "/intermediate-use-sold",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const uniqueBuyers = new Set(
        response.data.data.map((data) => data.client).filter(Boolean)
      );
      const buyerOptions = Array.from(uniqueBuyers).map((client) => ({
        value: client,
        name: client,
      }));
      setBuyerOptions(buyerOptions);
      setObjects(
        response.data.data.map((data) => {
          data.fuel_source = objectifyForDropdown(data.fuel_source);
          data.country_end_product = objectifyForDropdown(
            data.country_end_product
          );

          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const addIntermediateUseSoldToProduct = ({
  productId,
  product_name,
  country_end_product,
  fuel_source,
  client,
  end_product,
  end_product_num,
  weight,
  amount_per_use,
  amount_per_lifetime,
  times_end_product_used,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    product_name: product_name,
    country_end_product: country_end_product,
    fuel_source: fuel_source,
    client: client,
    end_product: end_product,
    end_product_num: end_product_num,
    amount_per_use: amount_per_use || null,
    amount_per_lifetime: amount_per_lifetime || null,
    weight: weight,
    times_end_product_used: times_end_product_used || null,
  });

  var config = {
    method: "post",
    url:
      baseUrl + "/api/business/product/" + productId + "/intermediate-use-sold",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
        setErrorMessage(error.response.data);
      }
    });
};

export const getProductIntermediateUseSold = ({
  id,
  setObjects,
  objects,
  componentId,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product/" +
      id +
      "/intermediate-use-sold/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          const gotValue = response.data.data;

          if (gotValue.id === supply.id) {
            gotValue.fuel_source = objectifyForDropdown(gotValue.fuel_source);
            gotValue.country_end_product = objectifyForDropdown(
              gotValue.country_end_product
            );
            return gotValue;
          }
          return supply;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateProductIntermediateUseSold = ({
  productId,
  componentId,
  product_name,
  country_end_product,
  fuel_source,
  client,
  end_product,
  end_product_num,
  weight,
  amount_per_use,
  amount_per_lifetime,
  times_end_product_used,
  objects,
  setObjects = function () {
    return;
  },
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    product_name: product_name,
    country_end_product: country_end_product,
    fuel_source: fuel_source,
    client: client,
    end_product: end_product,
    end_product_num: end_product_num,
    amount_per_use: amount_per_use || null,
    amount_per_lifetime: amount_per_lifetime || null,
    weight: weight,
    times_end_product_used: times_end_product_used || null,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/intermediate-use-sold/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.fuel_source = objectifyForDropdown(
              response.data.data.fuel_source
            );
            response.data.data.country_end_product = objectifyForDropdown(
              response.data.data.country_end_product
            );
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      setErrorMessage(error.response.data);
    });
};

export const deleteProductIntermediateUseSold = ({
  productId,
  componentId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/intermediate-use-sold/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};
